<template>
    <div>
        <div class="rel b:1|solid|#CECECE" :class="main ? 'p:12|48 r:100' : 'p:12|16 r:20'">
            <span class="abs f:14 font-weight:700">開課學校</span>
            <auto-complete
                class="pt:24 w:full outline:none"
                :items="info.colleges"
                :model-value="info.college_name"
                not-found-message="尚未提供該校課程評價"
                placeholder="輸入開課學校"
                :search-fields="['label', 'keywords']"
                @select="info.setCollege"
                @update:model-value="info.searchCollege"
            ></auto-complete>
        </div>
        <div class="color:red" :class="main ? 'pl:48' : 'pl:16'" v-if="info.errors.college">請選擇開課學校</div>
        <div class="rel b:1|solid|#CECECE mt:16" :class="main ? 'p:12|48 r:100' : 'p:12|16 r:20'">
            <span class="abs f:14 font-weight:700">課程名稱</span>
            <auto-complete
                class="pt:24 w:full outline:none"
                :items="info.courses"
                :model-value="info.course_name"
                not-found-message="查無此課程"
                placeholder="輸入課程名稱"
                @select="info.setCourse"
                @update:model-value="info.searchCourse"
            ></auto-complete>
        </div>
        <div class="color:red" :class="main ? 'pl:48' : 'pl:16'" v-if="info.errors.course">請選擇課程</div>
        <div class="flex ai:center b:1|solid|#CECECE mt:16" :class="main ? 'p:12|48 r:100' : 'p:12|16 r:20'">
            <div class="rel flex:1">
                <span class="abs f:14 font-weight:700">老師名字</span>
                <auto-complete
                    class="pt:24 w:full outline:none"
                    :items="info.professors"
                    :model-value="info.professor_name"
                    not-found-message="查無此老師"
                    placeholder="輸入老師名字"
                    @select="info.setProfessor"
                    @update:model-value="info.searchProfessor"
                ></auto-complete>
            </div>
            <div class="w:1 h:32 bg:#CECECE" :class="main ? 'mx:36' : 'mx:16'"></div>
            <div class="rel flex:1">
                <span class="abs f:14 font-weight:700">授課年度</span>
                <auto-complete
                    class="pt:24 w:full outline:none"
                    :items="info.years"
                    placeholder="請選擇"
                    @select="info.setYear"
                    show-all-suggestions
                    :threshold="0"
                    v-model.trim="info.year_name"
                ></auto-complete>
            </div>
        </div>
        <div class="color:red" :class="main ? 'pl:48' : 'pl:16'" v-if="info.errors.professor">請選擇老師</div>
        <div class="color:red" :class="main ? 'pl:48' : 'pl:16'" v-if="info.errors.year">請選擇授課年度</div>
    </div>
</template>

<script setup>
    const info = useSearchInfo();

    defineProps({
        main: { default: false, type: Boolean }
    });
</script>
